import React from 'react';
import * as PropTypes from 'prop-types';
import UnityWebGL from './UnityWebGL';
import UnityConsole from './UnityConsole';
import { UNITY_MODE_CONSOLE, UNITY_MODE_WEBGL } from '../../constants/unity';

const Unity = React.memo(({ mode, ...params }) => {
  let unityComponent = <span>[no unity renderer provided]</span>;
  if (mode === UNITY_MODE_CONSOLE) {
    unityComponent = <UnityConsole {...params} />;
  } else if (mode === UNITY_MODE_WEBGL) {
    unityComponent = <UnityWebGL {...params} />;
  }
  return unityComponent;
});

Unity.propTypes = {
  mode: PropTypes.oneOf([UNITY_MODE_WEBGL, UNITY_MODE_CONSOLE]).isRequired,
  webPath: PropTypes.string,
  initialized: PropTypes.bool,
};

Unity.displayName = 'Unity';

export default Unity;
